var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5005 3.49975C6.5005 2.67193 7.17243 2 8.00025 2C8.82807 2 9.5 2.67193 9.5 3.49975C9.5 4.32757 8.82807 4.9995 8.00025 4.9995C7.17243 4.9995 6.5005 4.32757 6.5005 3.49975Z",
    fill: "#8B93A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5005 7.99975C6.5005 7.17193 7.17243 6.5 8.00025 6.5C8.82807 6.5 9.5 7.17193 9.5 7.99975C9.5 8.82757 8.82807 9.4995 8.00025 9.4995C7.17243 9.4995 6.5005 8.82757 6.5005 7.99975Z",
    fill: "#8B93A7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5005 12.4997C6.5005 11.6719 7.17243 11 8.00025 11C8.82807 11 9.5 11.6719 9.5 12.4997C9.5 13.3276 8.82807 13.9995 8.00025 13.9995C7.17243 13.9995 6.5005 13.3249 6.5005 12.4997Z",
    fill: "#8B93A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreMenuIcon);
export default __webpack_public_path__ + "static/media/more-menu-icon.a3d99792a9297c20b2473cd98a35cd8d.svg";
export { ForwardRef as ReactComponent };